// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1cbBI","row":"Node_row__2QNYU","label":"Node_label__2PeON","footer":"Node_footer__2PXKd"};